import { render, staticRenderFns } from "./Eighty-five_percent.vue?vue&type=template&id=04558e4b&scoped=true"
import script from "./Eighty-five_percent.vue?vue&type=script&lang=js"
export * from "./Eighty-five_percent.vue?vue&type=script&lang=js"
import style0 from "./Eighty-five_percent.vue?vue&type=style&index=0&id=04558e4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04558e4b",
  null
  
)

export default component.exports